// extracted by mini-css-extract-plugin
module.exports = {"TabsWrapper":"TabsWrapper_TabsWrapper__WB9oP"};